<div mat-dialog-content class="modal-content">
  <div class="modal-header">
    <h5 class="title-box">
      Termos e Condições Gerais de Uso
    </h5>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">
      <i class="fa-light fa-times-circle"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="intro">Os presentes termos dispõem sobre a ferramenta de precificação on-line.</div>
    
    <h6>Plataforma</h6>
    Essa ferramenta de precificação on-line, consiste em uma plataforma na qual o consumidor disponibiliza informações 
    do seu veículo para receber uma sugestão de preço por parte da concessionária, automaticamente. Não se trata de uma 
    ferramenta de vendas e sim de um processo de precificação no qual os valores apresentados não configuram um 
    compromisso de compra por parte da concessionária, mas sim uma sugestão de preço para iniciar a negociação.
    <h6>Precificação</h6>
    O processo é realizado online mediante inserção de dados pelo cliente proprietário do veículo, sendo que a 
    assertividade desta jornada de precificação depende da veracidade dos dados informados. Quando houver interesse de 
    negociação, deve ser agendada uma validação presencial do veículo para certificação dos dados informados.
    <h6>Informações Importantes</h6>
    Para dar início a precificação veicular são necessários os seguintes dados do veículo: placa e quilometragem, informados pelo consumidor.<br/>
    As informações do consumidor necessárias são: nome, e-mail, cpf e telefone.
    <br/><br/>
    Estes dados serão recebidos e armazenados pela Auto Arremate e compartilhados com a concessionária parceira.
    <br/><br/><br/>

    O consumidor deverá ler atentamente este documento e, em caso de dúvidas, poderá entrar em contato por meio do 
    telefone e WhatsApp <a href="tel:55-16-3904-3702">+55 16 3904.3702</a>  (todas as localidades) e e-mail <a href="mailto:suporte@autoarremate.com.br" target="_blank">suporte&#64;autoarremate.com.br</a> (“Canais de Atendimento”). 
    Os dados poderão ser excluídos a qualquer momento mediante solicitação do cliente através dos canais Auto Arremate:<br/>
    <br/>
    As informações de contato dos Canais de Atendimento também estão disponíveis na Plataforma Auto Arremate.
    <br/>
    Veja mais detalhes em: <a href="https://www.autoarremate.com.br/termos-de-uso-autoarremate/">https://www.autoarremate.com.br/termos-de-uso-autoarremate/</a>

  </div>
</div>